import { supabase, isSupabaseConfigured } from '../lib/supabase';

export function trackToolClick(toolId: string): void {
  if (!toolId || !isSupabaseConfigured()) return;
  const referrerPath =
    typeof window !== 'undefined' ? window.location.pathname : '';
  try {
    supabase
      .from('tool_clicks')
      .insert({ tool_id: toolId, referrer_path: referrerPath })
      .then(({ error }) => {
        if (error && import.meta.env.DEV) {
          console.warn('[trackToolClick] insert failed', error.message);
        }
      });
  } catch {
    // swallow — click logging must never break navigation
  }
}
